import { render, staticRenderFns } from "./CompanyNews.vue?vue&type=template&id=35e47140&scoped=true&"
import script from "./CompanyNews.vue?vue&type=script&lang=js&"
export * from "./CompanyNews.vue?vue&type=script&lang=js&"
import style0 from "./CompanyNews.vue?vue&type=style&index=0&id=35e47140&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e47140",
  null
  
)

export default component.exports